import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import ScrollArea from 'react-scrollbar';
import Message from '../AdminSupportMessage';
import { answerSupportMessage, cancelUserMessages, getUserMessages, getUserMessagesLive, stopGetUserMessagesLive, setSupportMessageAsResponded, supportMessageFileUpload, setChatTyping, getChatTypingLive, stopGetChatTypingLive, answerSupportMessageMultiple } from '../../../../actions/admin';
import { connect } from 'react-redux';

import {
  ALLLOW_FILE,
  FROUNT_SIDE_STATUS,
} from '../../../../constants/constants';

const Chat = ({
    cancelActiveUserMessages,
    answerSupportMsg,
    answerSupportMessageMultiple,
    fetchUserMessages,
    fetchUserMessagesLive,
    stopFetchUserMessagesLive,
    supportAMessageFileUpload,
    setSupportMsgAsResponded,

    chatMessages,
    openChatModal,

    openChatModalMultiple,
    selectedUsers,

    setOpenChatModal,
    openChatModalName,
    setOpenChatModalName,
    openChatModalUid,
    setOpenChatModalUid,
    showNotification,
    setChatTypingFunc,
    getChatTypingLiveFunc,
    stopGetChatTypingLiveFunc,
    typingUser,
    typingAdmin,
    typingAdminUid,
    uid,
}) => {
    const hiddenFileInput = useRef(null);

    const messagesScrollbar = useRef(null);
    const [inputMessageEN, setInputMessageEN] = useState('');
    const [inputMessageLV, setInputMessageLV] = useState('');
    const [inputMessageRU, setInputMessageRU] = useState('');

    const [fileUploadUrl, setFileUploadUrl] = useState('');
    const [fileName, setFileName] = useState('');
    const [ableToSend, setAbleToSend] = useState(true);
    const [displayTyping, setDisplayTyping] = useState(false);
    const [chatDisplayBlock, setChatDisplayBlock] = useState(true);

    const [chatMessagesMultiple, setChatMessagesMultiple] = useState({});

    const [sendCoinsAllow, setSendCoinsAllow] = useState(false);
    const [sendCoinsAmount, setSendCoinsAmount] = useState('');
    const [sendBonusConfirm, setSendBonusConfirm] = useState(false);
    const [openChatModalMore, setOpenChatModalMore] = useState(false);
    const [grantVIP, setGrantVIP] = useState(false);

    const typingCooldownSet = useRef(false);

    useEffect(() => {
        if (!isNaN(typingUser)) {

            if (Date.now() - typingUser <= 1000) {
                setDisplayTyping(true);

                const typingTimeout = setTimeout(() => {
                    setDisplayTyping(false);
                }, 5000);

                return () => clearTimeout(typingTimeout);
            }
        }
    }, [typingUser])

    useEffect(() => {
        if (messagesScrollbar.current) {
            messagesScrollbar.current.scrollArea.scrollBottom();
        }
    }, [chatMessages])

    useEffect(() => {
        if (!isNaN(typingAdmin) && typingAdminUid !== uid) {

            if (Date.now() - typingAdmin <= 1000) {
                setDisplayTyping(true);

                const typingTimeout = setTimeout(() => {
                    setDisplayTyping(false);
                }, 5000);

                return () => clearTimeout(typingTimeout);
            }
        }
    }, [typingAdmin, typingAdminUid])


    useEffect(() => {
        if (openChatModal) {
            fetchUserMessagesLive(openChatModalUid)
                .then(() => {
                    setChatDisplayBlock(false);
                });
            getChatTypingLiveFunc(openChatModalUid);
            setFileName('');
            setFileUploadUrl('');
        }
    }, [openChatModal])

    useEffect(() => {
        return () => {
            stopFetchUserMessagesLive(openChatModalUid);
            stopGetChatTypingLiveFunc(openChatModalUid);
        };
    }, []);

    const toggleChat = () => {    
        if (openChatModal) {
            stopFetchUserMessagesLive(openChatModalUid);
            stopGetChatTypingLiveFunc(openChatModalUid);
            //cancelActiveUserMessages(openChatModalUid);
            setChatDisplayBlock(true);

        }
    
        setOpenChatModal(!openChatModal);
        setOpenChatModalUid('');
        setOpenChatModalName('');
        setInputMessageEN('');
        setOpenChatModalMore(false);
        setSendCoinsAllow(false);
        setSendCoinsAmount('');
        setGrantVIP(false);
    }

    const handleChangeChat = (event) => {
        //if (event.key !== 'Enter' || (event.key === 'Enter' && event.shiftKey)) {

            if (event.target.name === 'inputMessageEN') {
                setInputMessageEN(event.target.value);
            } else if (event.target.name === 'inputMessageLV') {
                setInputMessageLV(event.target.value);
            } else if (event.target.name === 'inputMessageRU') {
                setInputMessageRU(event.target.value);
            }

            if (!typingCooldownSet.current) {
                setChatTypingFunc(openChatModalUid, 'admin');
                typingCooldownSet.current = true;

                setTimeout(() => {
                    typingCooldownSet.current = false;
                }, 5000);
            }
        //}
    }

    const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'Enter' && !e.shiftKey && !e.altKey) {
            e.preventDefault();

            if (openChatModalMultiple) {
                if (sendCoinsAllow || grantVIP) {
                    toggleSendBonusConfirm();
                } else {
                    submitMessageMultiple();
                }
            } else {
                submitMessage();
            }
        }
    };

    const toggleSendBonusConfirm = () => {
        setSendBonusConfirm(!sendBonusConfirm);
    }

    const submitMessage = () => {
        if (inputMessageEN !== '' || fileUploadUrl !== '') {
            answerSupportMsg({
                uid: openChatModalUid, message: inputMessageEN, fileUploadUrl, fileName,
            }).then(() => {
    
                // fetchUserMessages(openChatModalUid).then((res) => {
                // });
        
                //  this.scrollToBottom();
                setInputMessageEN('');
                setFileUploadUrl('');
                setFileName('');
          });
        }
    }


    const submitMessageMultiple = () => {
        if (!inputMessageEN || !inputMessageLV || !inputMessageRU) {
            showNotification('Error', "Missing message", FROUNT_SIDE_STATUS.danger);
            return;
        }

        const coins = sendCoinsAllow && sendCoinsAmount && !isNaN(sendCoinsAmount) ? parseInt(sendCoinsAmount) : 0;

        answerSupportMessageMultiple({
            uids: selectedUsers,
            messageEN: inputMessageEN,
            messageLV: inputMessageLV,
            messageRU: inputMessageRU,
            fileUploadUrl,
            fileName,
            coins,
            grantVIP,
        }).then((res) => {
            let messageSuccess = true;
            for (const playerRes of res) {
                if (!playerRes.status || playerRes.status !== 'success') {
                    messageSuccess = false;
                    break;
                }
            }
    
            if (messageSuccess) {
                showNotification('Success', "Message sent succesfully.", FROUNT_SIDE_STATUS.success);
            } else {
                showNotification('Error', "Error sending message.", FROUNT_SIDE_STATUS.danger);
            }
    
            if (coins !== 0) {
                let coinsSuccess = true;
                for (const playerRes of res) {
                    if (!playerRes.balanceResult || !playerRes.balanceResult.status || playerRes.balanceResult.status !== 'success') {
                        coinsSuccess = false;
                        break;
                    }
                }
        
                if (coinsSuccess) {
                    showNotification('Success', "Coins sent succesfully.", FROUNT_SIDE_STATUS.success);
                } else {
                    showNotification('Error', "Error sending coins.", FROUNT_SIDE_STATUS.danger);
                }
    
            }
            
            const newChatMessagesMultiple = { ...chatMessagesMultiple };
            const multipleMsgCount = Object.keys(newChatMessagesMultiple).length;
    
            newChatMessagesMultiple[multipleMsgCount] = {date: Date.now(), message: inputMessageLV};

            setInputMessageEN('');
            setInputMessageLV('');
            setInputMessageRU('');
            setFileUploadUrl('');
            setFileName('');
            setChatMessagesMultiple(newChatMessagesMultiple);
        });

    }

    const chooseFile = (e) => {
        e.preventDefault();
    
        const target = e.target.files[0];
        const typeList = '.jpg,.jpeg,.png,.pdf,.msword,.doc,.rtf,.txt,ain';
        if (!target || (target && target.length === 0)) return;
        if (!typeList.includes((target.type).substring((target.type).length - 3)) || target.type == '') { return showNotification('Error!', "Unsupported file!", 'danger'); }
      if (target.size / ALLLOW_FILE.unitSize > ALLLOW_FILE.allowSize) {
          showNotification('Warning', "Can't upload more than 5 MB", 'warning');
          setFileUploadUrl('');
          setFileName('');
        } else {
          setAbleToSend(false);
          supportAMessageFileUpload(target).then((data) => {
            setFileUploadUrl(data.url);
            setFileName(data.url);
            setAbleToSend(true);
            showNotification('Success', "File successfully attached!", 'success');
          });
        }
    }

    const setSupportMessageAsRespondedFunc = () => {
        setSupportMsgAsResponded({ uid: openChatModalUid }).then(() => {
            setOpenChatModal(false);
        });
    }

    return (
        <>
            <Modal container={'div > div'} isOpen={openChatModal} toggle={toggleChat}>
                <ModalHeader toggle={toggleChat}>
                    {`Chat - ${openChatModalName} - ${openChatModalUid}`}
                </ModalHeader>
                <ModalBody>
                    <Row className="chat-body">
                        <Col className="chat-body-wrapper" md="12">
                            <ScrollArea
                                speed={0.65}
                                className={`admin-chat-scroll-area ${openChatModalMultiple && 'admin-chat-scroll-area-multiple'}`}
                                contentClassName="admin-chat-scroll-content"
                                //  smoothScrolling
                                verticalContainerStyle={{
                                    background: 'transparent',
                                    opacity: 1,
                                    width: 10,
                                }}
                                verticalScrollbarStyle={{
                                    background: '#fff',
                                    borderRadius: 2,
                                    width: 6,
                                    minHeight: 30,
                                    minScrollSize: 35,
                                }}
                                horizontal={false}
                                //ref={(el) => { this.messagesScrollbar = el; }}
                                ref={messagesScrollbar}
                            >
                                {!openChatModalMultiple && chatMessages && !chatDisplayBlock && Object.keys(chatMessages).map(key => (
                                    <Row key={key}>
                                        <Col md="12">
                                            <Message message={chatMessages[key]} />
                                        </Col>
                                    </Row>
                                ))}

                                {openChatModalMultiple && chatMessagesMultiple && Object.keys(chatMessagesMultiple).map(key => {
                                    return (
                                        <Row key={key}>
                                            <Col md="12">
                                                <Message message={chatMessagesMultiple[key]} />
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </ScrollArea>
                            <div style={{opacity: displayTyping ? 1 : 0}} className="chat-body-typing" />

                        </Col>
                    </Row>
                    <Row className="chat-footer" style={{ height: openChatModalMultiple ? 'auto' : 60 }}>
                        <Form style={{ width: '100%', height: '100%' }}>
                            <Col md="12" style={{ height: '100%' }}>
                                {openChatModalMultiple && (
                                    <>
                                        Latvian
                                        <Input
                                            className="h-100 chat-footer-input chat-footer-input-admin"
                                            type="textarea"
                                            name="inputMessageLV"
                                            id="inputMessageLV"
                                            autoComplete="off"
                                            placeholder='Type a message... (Ctrl + Enter to send)'
                                            value={inputMessageLV}
                                            onChange={handleChangeChat}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </>
                                )}

                                {openChatModalMultiple && (
                                    <>English</>
                                )}
                                <Input
                                    className="h-100 chat-footer-input chat-footer-input-admin"
                                    type="textarea"
                                    name="inputMessageEN"
                                    id="inputMessageEN"
                                    autoComplete="off"
                                    placeholder='Type a message... (Ctrl + Enter to send)'
                                    value={inputMessageEN}
                                    onChange={handleChangeChat}
                                    onKeyDown={handleKeyDown}
                                />

                                {openChatModalMultiple && (
                                    <>
                                        Russian
                                        <Input
                                            className="h-100 chat-footer-input chat-footer-input-admin"
                                            type="textarea"
                                            name="inputMessageRU"
                                            id="inputMessageRU"
                                            autoComplete="off"
                                            placeholder='Type a message... (Ctrl + Enter to send)'
                                            value={inputMessageRU}
                                            onChange={handleChangeChat}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </>
                                )}

                            </Col>
                        </Form>
                    </Row>
                    <Row style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Button
                            className="btn-warning admin-file-upload-button"
                            onClick={() => hiddenFileInput.current.click()}
                        >
                            {fileName === '' ? '+ Choose File' : fileName}
                        </Button>
                        <input
                            id="files"
                            hidden
                            ref={hiddenFileInput}
                            className="chat-footer-input chat-footer-input-admin admin-file-upload-input"
                            accept=".jpg,.jpeg,.png,.pdf,.msword,.doc,.rtf,.txt,ain"
                            type="file"
                            onChange={chooseFile}
                        />

                        {openChatModalMultiple && (
                            <div style={{marginRight: 20}}>
                                More
            
                                <div className="admin-arrow-wrapper ml-2" onClick={() => setOpenChatModalMore(!openChatModalMore)}>
                                <div className={openChatModalMore ? 'admin-arrow-down' : 'admin-arrow-up'} />
                                </div>
                            </div>
                        )}
                    </Row>
                                  
                    <Row>
                        {openChatModalMore && (
                            <>
                                <Col xs="12" className="d-flex flex-row align-items-center mt-2">
                                    <Label for="sendCoinsAllow" check>
                                        <Input
                                            id="sendCoinsAllow"
                                            type="checkbox"
                                            onClick={
                                                () => {
                                                    setSendCoinsAllow(!sendCoinsAllow);
                                                    setSendCoinsAmount(sendCoinsAllow ? '' : sendCoinsAmount);
                                                }
                                            }
                                            checked={sendCoinsAllow}
                                            readOnly
                                        />
                                        Send coins
                                    </Label>
                    
                                    <Input
                                        style={{width: 200, marginLeft: 10}}
                                        disabled={!sendCoinsAllow}
                                        type="text"
                                        name="sendCoinsAmount"
                                        id="sendCoinsAmount"
                                        value={sendCoinsAmount}
                                        // onChange={(e) => this.setState({ sendCoinsAmount: e.target.value })}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (
                                                value === "" ||
                                                value === "-" ||
                                                /^-?(0|[1-9]\d{0,5})$/.test(value)
                                            ) {
                                                setSendCoinsAmount(value);
                                            }
                                        }}
                                    />
                                </Col>

                                <Col xs="12" className="d-flex flex-row align-items-center mt-2">
                                    <Label for="grantVIP" check>
                                        <Input
                                            id="grantVIP"
                                            type="checkbox"
                                            onClick={() => setGrantVIP(!grantVIP)}
                                            checked={grantVIP}
                                            readOnly
                                        />
                                        Grant VIP status (1 month)
                                    </Label>
                                </Col>

                            </>
                        )}
                        
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" color="secondary" onClick={setSupportMessageAsRespondedFunc}>Mark As Read</Button>

                    <Button
                        className="contact-support-footer-button"
                        disabled={
                            !ableToSend ||
                            (sendCoinsAllow && (!sendCoinsAmount || sendCoinsAmount === '0' || sendCoinsAmount === '-' || sendCoinsAmount === '-0'))
                        }
                        color="primary"
                        onClick={
                            openChatModalMultiple
                                ? ((sendCoinsAllow || grantVIP) ? toggleSendBonusConfirm : submitMessageMultiple)
                                : submitMessage
                        }
                    >
                        Send
                    </Button>
                    <Button type="button" color="secondary" onClick={toggleChat}>Close</Button>
                </ModalFooter>
            </Modal>


            <Modal container={`div > div`} isOpen={sendBonusConfirm} toggle={toggleSendBonusConfirm}>
                <ModalHeader toggle={toggleSendBonusConfirm}>
                    Send mass message with bonus
                </ModalHeader>

                <ModalBody className="text-center">
                    Do you really want to send bonus?
                </ModalBody>
                <ModalFooter>
                <Button
                    type="button"
                    color="primary"
                    onClick={() => {
                        submitMessageMultiple();
                        toggleSendBonusConfirm();
                    }}
                >
                    Yes
                </Button>
                <Button
                    type="button"
                    color="secondary"
                    onClick={toggleSendBonusConfirm}
                >
                    No
                </Button>
                </ModalFooter>
            </Modal>
        </>


        
    );
};

const mapStateToProps = state => ({
    chatMessages: state.admin.chatMessages || {},
    typingUser: state.admin.typingUser,
    typingAdmin: state.admin.typingAdmin,
    typingAdminUid: state.admin.typingAdminUid,
    uid: state.member.uid,
});

const mapDispatchToProps = {
    getChatTypingLiveFunc: getChatTypingLive,
    stopGetChatTypingLiveFunc: stopGetChatTypingLive,
    setChatTypingFunc: setChatTyping,
    supportAMessageFileUpload: supportMessageFileUpload,
    cancelActiveUserMessages: cancelUserMessages,
    fetchUserMessages: getUserMessages,
    fetchUserMessagesLive: getUserMessagesLive,
    stopFetchUserMessagesLive: stopGetUserMessagesLive,
    answerSupportMsg: answerSupportMessage,
    answerSupportMessageMultiple: answerSupportMessageMultiple,
    setSupportMsgAsResponded: setSupportMessageAsResponded,
};
  
  
export default connect(mapStateToProps, mapDispatchToProps)(Chat);
